import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.5265 7.47338H7.47386M7.47386 7.47338H10.4212M7.47386 7.47338V10.4207M7.47386 7.47338V4.52601M7.47386 14.105C3.81134 14.105 0.842285 11.1359 0.842285 7.47338C0.842285 3.81086 3.81134 0.841797 7.47386 0.841797C11.1364 0.841797 14.1054 3.81086 14.1054 7.47338C14.1054 11.1359 11.1364 14.105 7.47386 14.105Z",
      stroke: "#475569",
      "stroke-width": "1.68421",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }